import gql from 'graphql-tag';

export const userLoggedQuery = gql`
  query loggedUser{
    loggedUser {
      id
      name
      lastName
      phoneNumber
      email
      outgoingEmail
      role
      language
      notificationDeliveryMethod
      company {
        id
        name
        companyConfiguration {
          leadinLive
          testAb
          dropdownWithRules
          logoPath
        }
      }
    }
  }
`;

export const brandsQuery = gql`
  query getBrands($brandInput: BrandInput){
    getBrands(brandInput: $brandInput){
      brands{
        id
        name
        photo
      }
      totalCount
    }
  }
`;

export const channelsQuery = gql`
  query getChannels($channelInput: ChannelInput){
    getChannels(channelInput: $channelInput){
      channels{
        id
        name
        photo
        color
      }
      totalCount
    }
  }
`;

export const statusQuery = gql`
  query getStatuses{
    getStatuses{
      statuses{
        name
        subStatuses{
          name
        }
      }
    }
  }
`;

export const leadTypeQuery = gql`
  query getLeadTypes{
    getLeadTypes {
      types{
        name
      }
    }
  }
`;

export const getOriginsQuery = gql`
  query getOrigins($getOriginsInput: GetOriginsInput) {
    getOrigins(getOriginsInput: $getOriginsInput) {
      origins
      canCreateNew
    }
  }
`;

export const usersQuery = gql`
  query getUsers($userInput: UserInput){
    getUsers(userInput: $userInput){
      users{
        id
        name
        lastName
      }
      totalCount
    }
  }
`;

export const usersByRolQuery = gql`
  query getUsersByRol($userInput: UserInput){
    getUsersByRol(userInput: $userInput){
      users{
        id
        name
        lastName
      }
      totalCount
    }
  }
`;

export const usersByRolForCalendarQuery = gql`
  query getUsersByRolForCalendars($userInput: UserInput){
    getUsersByRolForCalendars(userInput: $userInput){
      users{
        id
        name
        lastName
      }
      totalCount
    }
  }
`;

export const dealersQuery = gql`
  query getDealers($dealerInput:DealerInput){
    getDealers(dealerInput:$dealerInput){
      dealers{
        id
        name
      }
      totalCount
    }
  }
`;

export const getDealersByCompanyId = gql`
query getDealersByCompanyId($input: String){
  getDealersByCompanyId(companyId: $input){
      id
      name
  }
}
`;

export const getLinkInvitation = gql`
  query getLinkInvitation($input: String){
    getLinkInvitation(leadId: $input){
        clientId
        tokenMeet
        shortId
        isNew
    }
  }
`;

export const getTokenMeetByShortId = gql`
  query getTokenMeetByShortId($input: String) {
    getTokenMeetByShortId(shortId: $input)
  }
`;

export const metricsSalesFunnelQuery = gql`
  query getMetricsSalesFunnel($metricsSalesFunnelInput: GetMetricsSalesFunnelInput){
    getMetricsSalesFunnel(metricsSalesFunnelInput:$metricsSalesFunnelInput)
    {
      totalLeads
      contactedLeads
      totalVisits
      visitedLeads
      closedLeads
      archivedLeads
      onTrackLeads
    }
  }
`;

export const metricsSalesUniqueFunnelQuery = gql`
  query getUniquesConcurrencesCount($getUniquesConcurrencesCountInput: GetUniquesConcurrencesCountInput){
    getUniquesConcurrencesCount(getUniquesConcurrencesCountInput: $getUniquesConcurrencesCountInput)
    {
      total
    }
  }
`;

export const getMetricsMarketingTotal = gql`
  query getMetricsMarketingTotal($metricsMarketingTotalInput: GetMetricsMarketingTotalInput){
    getMetricsMarketingTotal(getMetricsMarketingTotalInput:$metricsMarketingTotalInput)
    {
      totalLeads
      contactedLeads
      totalVisits
      visitedLeads
      closedLeads
      onTrackLeads
    }
  }
`;
export const getMetricsSalesTimeReport = gql`
  query getMetricsSalesTimeReport($metricInput: GetMetricsSalesTimeReportInput){
    getMetricsSalesTimeReport(getMetricsSalesTimeReportInput:$metricInput)
    {
      contactedLeads_0_15
      contactedLeads_15_30
      contactedLeads_30_45
      contactedLeads_45_60
      contactedLeads_60_75
      contactedLeads_75_90
      contactedLeads_90_105
      contactedLeads_105_120
      contactedLeads_120_240
      contactedLeads_moreThan_240
      bussinessContactedLeads_0_15
      bussinessContactedLeads_15_30
      bussinessContactedLeads_30_45
      bussinessContactedLeads_45_60
      bussinessContactedLeads_60_75
      bussinessContactedLeads_75_90
      bussinessContactedLeads_90_105
      bussinessContactedLeads_105_120
      bussinessContactedLeads_120_240
      bussinessContactedLeads_moreThan_240
    }
  }
`;
export const getMetricsSalesTimeReportByUser = gql`
  query getMetricsSalesTimeReportByUser($metricInput: GetMetricsSalesTimeReportInput){
    getMetricsSalesTimeReportByUser(getMetricsSalesTimeReportInput:$metricInput)
    {
      timeReportByUser {
        user {
          id
          name
        }
        timeReport {
          contactedLeads_0_15
          contactedLeads_15_30
          contactedLeads_30_45
          contactedLeads_45_60
          contactedLeads_60_75
          contactedLeads_75_90
          contactedLeads_90_105
          contactedLeads_105_120
          contactedLeads_120_240
          contactedLeads_moreThan_240
          bussinessContactedLeads_0_15
          bussinessContactedLeads_15_30
          bussinessContactedLeads_30_45
          bussinessContactedLeads_45_60
          bussinessContactedLeads_60_75
          bussinessContactedLeads_75_90
          bussinessContactedLeads_90_105
          bussinessContactedLeads_105_120
          bussinessContactedLeads_120_240
          bussinessContactedLeads_moreThan_240
        }
      }
    }
  }
`;

export const getRawHtml = gql`
  query getRawHtml($leadInput: GetRawHtmlInput){
    getRawHtml(getRawHtmlInput:$leadInput)
    {
      emailSubject
      rawHtml
      rawText
    }
  }
`;
export const getClosestEvent = gql`
  query getClosestEvent($input: [GetClosestEventInput]){
    getClosestEvent(getClosestEventInput:$input)
    {
      type
      dateFrom
      leadId
    }
  }
`;

export const customFilterCounts = gql`
query customFilterCounts {
  customFilterCounts {
    customFilterCounts{
      new
      pending
      open
    }
  }
}
`;

export const getLeads = gql`
query getLeads($input: GetLeadsInput,$isDownloadCsv: Boolean!){
  getLeads(getLeadsInput: $input){
    leads{
      id
      status
      onTrack
      contactName
      contactPhone
      contactEmail
      vat
      plate @include(if: $isDownloadCsv)
      type
      descriptionModel
      comments
      transferred
      assignedDate
      firstCallDate
      firstContactDate
      firstInteractionDate
      endDefeatDate
      visitDate
      reminderDate
      origin
      createdAt
      updatedAt
      inCall
      inInteraction
      hasHtml
      tags
      postalCode
      location
      address
      scoring
      prequalification
      pendingVisitDate
      failVisitDate
      integrationType
      closestEventsByType @include(if: $isDownloadCsv){
        visitClosestEvent {
          type
          dateFrom
        }
        reminderClosestEvent {
          type
          dateFrom
        }
      }
      user {
        id
        name
        lastName
      }
      dealer
      brand
      channel
    }
    totalCount,
  }
}
`;

export const getLeadById = gql`
  query getLeadById($input: GetLeadByIdInput, $addHasMessageId: Boolean!){
    getLeadById(getLeadByIdInput: $input){
      lead{
        id
        status
        onTrack
        contactName
        contactPhone
        contactEmail
        vat
        emailSubject
        descriptionModel
        type
        comments
        transferred
        assignedDate
        firstCallDate
        firstContactDate
        firstInteractionDate
        visitDate
        reminderDate
        origin
        createdAt
        updatedAt
        hasHtml
        inCall
        inInteraction
        tags
        postalCode
        location
        address
        brand {
          id
          name
          photo
        }
        channel {
          id
          name
          color
        }
        user{
          id
          name
          lastName
          phoneNumber
          email
        }
        dealer {
          id
          name
          contactAddress
        }
        hasMessageId @include(if: $addHasMessageId)
        prequalification
        scoring
        sentToAutonet
        plate
      }
    }
  }
`;

export const getLeadsByPlate = gql`
  query getLeadsByPlate($input: GetLeadsByPlateInput){
    getLeadsByPlate(getLeadsByPlateInput: $input){
      leads{
      id
      status
      onTrack
      contactName
      contactPhone
      contactEmail
      vat
      type
      descriptionModel
      comments
      transferred
      assignedDate
      firstCallDate
      firstContactDate
      firstInteractionDate
      endDefeatDate
      visitDate
      reminderDate
      origin
      createdAt
      updatedAt
      inCall
      inInteraction
      hasHtml
      tags
      postalCode
      location
      address
      scoring
      prequalification
      pendingVisitDate
      failVisitDate
      integrationType
      user {
        id
        name
        lastName
      }
      dealer
      brand
      channel
    }
    totalCount,
  }
  }
`;

export const getHistoricOfLead = gql`
  query getHistoricOfLead($input: GetHistoricInput){
    getHistoricOfLead(getHistoricInput: $input){
      historics{
        id
        comments
        createdAt
        method
        status
        onTrack
        callDurationSeconds
        phone
        emailSubject
        emailTo
        emailFrom
        message
        archivedOption
        user {
          id
          name
          lastName
        }
        affected {
          id
          name
          lastName
        }
        reminderDate
        lead {
          closeDate
        }
      }
      totalItems
    }
  }
`;

export const getMetricsSalesMen = gql`
  query getMetricsSalesMan($input: GetMetricSalesmanInput) {
    getMetricsSalesMan (getMetricsSalesmanInput: $input) {
      metricsSalesMen {
        salesManId
        salesManName
        assignedLeads
        archivedLeads
        onTrackLeads
        contactedLeads
        totalSecondsCalls
        totalVisits
        visitedLeads
        closedLeads
        totalInteractions
      }
      totalLeads
    }
  }
`;

export const getMetricsMarketingLeadsPerChannelTime = gql`
query getMetricsMarketingLeadsPerChannelTime($input: GetMetricsMarketingLeadsPerChannelTimeInput) {
  getMetricsMarketingLeadsPerChannelTime(getMetricsMarketingLeadsPerChannelTimeInput: $input) {
    marketingLeadsPerChannelTime {
      channelName
      channelColor
      leads0
      leads1
      leads2
      leads3
      leads4
			leads5
      leads6
      leads7
      leads8
      leads9
      leads10
      leads11
      leads12
      leads13
      leads14
      leads15
      leads16
      leads17
      leads18
      leads19
      leads20
      leads21
      leads22
      leads23
    }
  }
}
`;

export const getMetricsMarketingLeadsPerChannelDayWeek = gql`
query getMetricsMarketingLeadsPerChannelDayWeek($input: GetMetricsMarketingLeadsPerChannelDayWeekInput) {
  getMetricsMarketingLeadsPerChannelDayWeek(getMetricsMarketingLeadsPerChannelDayWeekInput: $input) {
    marketingLeadsPerChannelDayWeek {
      channelName
      channelColor
      leadsMonday
      leadsTuesday
      leadsWednesday
      leadsThursday
      leadsFriday
      leadsSaturday
      leadsSunday
    }
  }
}
`;

export const getMetricsMarketingLeadsPerChannel = gql`
query getMetricsMarketingLeadsPerChannel($input: GetMetricsMarketingLeadsPerChannelInput) {
  getMetricsMarketingLeadsPerChannel (getMetricsMarketingLeadsPerChannelInput: $input){
    marketingLeadsPerChannel {
      channelId
      channelName
      channelColor
      totalLeads
      archivedLeads
      onTrackLeads
      contactedLeads
      totalVisits
      visitedLeads
      closedLeads
    }
  }
}
`;

export const getMetricsMarketingLeadsPerDealer = gql`
query getMetricsMarketingLeadsPerDealer($input: GetMetricsMarketingLeadsPerDealerInput) {
  getMetricsMarketingLeadsPerDealer (getMetricsMarketingLeadsPerDealerInput: $input){
    marketingLeadsPerDealer {
      dealerId
      dealerName
      totalLeads
    }
  }
}
`;

export const getMetricsLeadsPerBrand = gql`
query getMetricsLeadsPerBrand($input: GetMetricsLeadsPerBrandInput) {
  getMetricsLeadsPerBrand (getMetricsLeadsPerBrandInput: $input){
    metricsMarketingLeadsPerBrand {
      totalLeads
      brandName
    }
  }
}
`;

export const getMetricsLeadsPerLeadType = gql`
query getMetricsLeadsPerLeadType($input: GetMetricsLeadsPerLeadTypeInput) {
  getMetricsLeadsPerLeadType (getMetricsLeadsPerLeadTypeInput: $input){
    metricsLeadsPerLeadType {
      totalLeads
      leadType
    }
  }
}
`;

export const getMetricsMarketingLeadsPerArchivedType = gql`
query getMetricsMarketingLeadsPerArchivedType($input: GetMetricsMarketingLeadsPerArchivedTypeInput) {
  getMetricsMarketingLeadsPerArchivedType (getMetricsMarketingLeadsPerArchivedTypeInput: $input){
    marketingLeadsPerArchivedType {
      not_contacted
      not_interested
      other
      by_price
      by_financing
      by_appraisal
      immature
      samebrand
      samebrand_dealership
      anotherbrand
      anotherbrand_dealership
      totalLeads
    }
  }
}`;

export const canMakeCallQuery = gql`
  query canMakeCall($input: CanMakeCallInput){
    canMakeCall(canMakeCallInput: $input){
      result
      leadId
      inInteractionLeadId
      inInteractionLeadCompanyId
      callStartTime
      interactionTime
      needNextStep
    }
  }
`;

export const validateCsv = gql`
query getBrands($brandInput: BrandInput, $dealerInput: DealerInput, $channelInput:ChannelInput, $userInput: UserInput,$getOfferIdLeadsByOfferIdInput:GetOfferIdLeadsByOfferIdInput){
	getBrands(brandInput:$brandInput){
    brands {
      id
      name
    }
  },
  getDealers(dealerInput:$dealerInput){
    dealers {
      id
      name
    }
  },
  getChannels(channelInput:$channelInput){
    channels {
      id
      name
    }
  },
  getUsers(userInput:$userInput){
    users {
      id
      name
    }
  },
  getOfferIdLeadsByOfferId(getOfferIdLeadsByOfferIdInput:$getOfferIdLeadsByOfferIdInput){
    leads
  },
  getLeadTypes {
      types{
        name
      }
    }
}
`;

export const getUserLoggedCompanies = gql`
  query getUserLoggedCompanies{
    getUserLoggedCompanies {
      companies {
        id
        name
        companyConfiguration {
          leadinLive
          testAb
          logoPath
        }
      }
    }
  }
`;

export const getCompanyById = gql`
  query getCompanyById($input: GetCompanyByIdInput) {
    getCompanyById (getCompanyByIdInput: $input) {
        id
        name
    }
  }
`;
export const getCompanyConfiguration = gql`
query getCompanyConfiguration {
getCompanyConfiguration{
  timeZone
  assignmentMethodType
  businessHoursActived
  businessHours {
    id
    startTime
    endTime
  }
  timeForConcurrence
  sendWithCustomEmail
  dropdownWithRules
}
}
`;

export const getAssigmentMethod = gql`
query getAssigmentMethod {
  getAssigmentMethod
}
`;

export const getLeadEvents = gql`
  query getLeadEvents($input: GetLeadEventsInput) {
    getLeadEvents (getLeadEventsInput: $input) {
      events {
        id
        userId
        text
        type
        dateFrom
        dateTo
        textColor
        backgroundColor
        leadId
        isOutBusinessHours
        userRoleType
      }
      businessHours {
        id
        startTime
        endTime
        daysOfWeek
        active
        userId
      }
    }
  }
`;

export const getLeadEventsByCompanies = gql`
  query getLeadEventsByCompanies($input: GetLeadEventsInput) {
    getLeadEventsByCompanies (getLeadEventsByCompaniesInput: $input) {
      events {
        id
        userId
        text
        type
        dateFrom
        dateTo
        textColor
        backgroundColor
        leadId
        isOutBusinessHours
        userRoleType
      }
      businessHours {
        id
        startTime
        endTime
        daysOfWeek
        active
        userId
      }
    }
  }
`;

export const getMetricLeadById = gql`
  query getMetricLeadById($input: GetLeadByIdInput){
    getMetricLeadById(getLeadByIdInput: $input){
      metricLead {
          createdAt
          updatedAt
          firstAssignedDate
          firstUserAssigned
          firstInteractionDate
          firstContactBussinessSeconds
          firstContactDate
          endDefeatDate
          transferred
          assignedDate
          firstCallDate
          callStartTime
          onTrack
          realResponseTime
          timesTransferred
          timesEdited
          timesWithoutCallResponse
          durationWithoutCallResponse
          timesWithCallResponse
          durationWithCallResponse
          whatsappsSent
          emailsSent
          emailsReceived
          remindersScheduled
          visitScheduled
          totalInteractions
          postalCode
          location
          firstContactUserName
      }
    }
  }
`;

export const getLastVisitByLeadId = gql`
  query getLastVisitByLeadId($input: GetLastVisitByLeadIdInput) {
    getLastVisitByLeadId(getLastVisitByLeadIdInput: $input) {
        id
        status
        dateFrom
        leadId
        userId
        dateTo
    }
}
`;

export const getVehicles = gql`
  query getVehicles($input: GetVehiclesInput) {
    getVehicles(getVehiclesInput: $input) {
      vehicles {
        id
        status
        registrationPlate
        brand
        model
        engine
        registrationDate
        mileage
        fuel
        gearbox
        price
        financedPrice
        classification
        images {
          url
          sort
        }
        companyName
        installation
      },
      count
    }
  }
`;

export const getVehicle = gql`
  query getVehicle($vehicleInput: GetVehicleInput){
    getVehicle (getVehicleInput: $vehicleInput){
      id
      status
      registrationPlate
      brand
      model
      engine
      registrationDate
      mileage
      fuel
      gearbox
      price
      financedPrice
      classification
      images {
        url
        sort
      }
      companyName,
      installation,
    }
  }
`;

export const getVehicleFilters = gql`
  query getVehicleFilters {
    getVehicleFilters {
      brands
      fuelTypes
      gearboxTypes
      installations
      vehicleCompanies {
        id
        name
      }
    }
  }
`;

export const isCompany360Active = gql`
  query isCompany360Active {
    isCompany360Active
  }
`;

export const getAssignmentRules = gql`
  query getAssignmentRules($input: GetAssignmentRulesInput) {
    getAssignmentRules(getAssignmentRulesInput: $input) {
      assignmentRules {
        id
        name
        negativeRule
        leadType
        channel {
          id
          name
          photo
        }
        brand {
          id
          name
          photo
        }
        dealer {
          id
          name
        }
        user {
          id
          name
          lastName
          role
        }
        active
        origin
        postalCode
        updatedAt
      }
      assignmentRulesCount
    }
  }
`;

export const findInvesments = gql`
  query findInvestments($input: FindInvestmentsInput) {
    findInvestments(findInvestmentsInput: $input) {
      count
      investments {
        id
        campaign
        amount
        channel {
          id
          name
        }
        updatedAt
      }
    }
  }
`;

export const findInvestmentMetrics = gql`
  query findInvestmentMetrics($input: FindInvestmentMetricsInput) {
    findInvestmentMetrics(findInvestmentMetricsInput: $input) {
      investmentsMetrics {
        channelName
        channelId
        origin
        channelColor
        totalLeads
        archivedLeads
        onTrackLeads
        contactedLeads
        totalVisits
        visitedLeads
        closedLeads
        amount
      }
    }
  }
`;
